import axios from 'axios';
import { WebhookResponse, WebhookStatistics, ClearWebhookStatisticsResponse, WebhookListResponse, WebhookDetails } from './types';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const webhookApi = {
  // Send/receive a webhook payload for a partner (simulator endpoint)
  sendWebhook: async (partnerId: string, payload: unknown): Promise<WebhookResponse> => {
    const response = await apiClient.post<WebhookResponse>(`/partners/${partnerId}/webhooks`, payload);
    return response.data;
  },

  // Get webhook statistics for a partner
  getWebhookStatistics: async (partnerId: string): Promise<WebhookStatistics> => {
    const response = await apiClient.get<WebhookStatistics>(`/partners/${partnerId}/webhooks/statistics`);
    return response.data;
  },

  // Clear webhook statistics globally or for a specific partner
  clearWebhookStatistics: async (partnerId?: string): Promise<ClearWebhookStatisticsResponse> => {
    const url = partnerId ? `/admin/webhooks/clear?partnerId=${partnerId}` : '/admin/webhooks/clear';
    const response = await apiClient.delete<ClearWebhookStatisticsResponse>(url);
    return response.data;
  },

  // List webhooks for a partner with pagination and filtering
  listWebhooks: async (
    partnerId: string,
    options?: {
      limit?: number;
      offset?: number;
      eventType?: string;
    }
  ): Promise<WebhookListResponse> => {
    const params = new URLSearchParams();
    if (options?.limit !== undefined) params.append('limit', options.limit.toString());
    if (options?.offset !== undefined) params.append('offset', options.offset.toString());
    if (options?.eventType) params.append('eventType', options.eventType);

    const url = `/partners/${partnerId}/webhooks${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await apiClient.get<WebhookListResponse>(url);
    return response.data;
  },

  // Get detailed information about a specific webhook
  getWebhookDetails: async (partnerId: string, webhookId: string): Promise<WebhookDetails> => {
    const response = await apiClient.get<WebhookDetails>(`/partners/${partnerId}/webhooks/${webhookId}`);
    return response.data;
  },
};
